import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Eye, Send, CheckCircle2 } from "lucide-react";
import { Btn, Label, inputCls } from "@/components/argus/ui";
import { sendContact, contactErr } from "@/lib/contact";
import { ArgusLegalFooter } from "@/pages/ArgusLegal";

const TOPICS = ["General question", "Argus Journalist / Corporate", "Argus WHIP", "Lawyer directory listing", "Billing question", "Privacy request", "Legal notice", "Report a problem"];

export default function ArgusContact() {
  const [f, setF] = useState({ name: "", email: "", topic: TOPICS[0], message: "", website: "" });
  const [busy, setBusy] = useState(false); const [err, setErr] = useState(""); const [sent, setSent] = useState(false);
  useEffect(() => { document.title = "Contact Argus"; }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await sendContact(f, f.topic === "Argus WHIP" ? "whip" : "argus"); setSent(true); }
    catch (e2) { setErr(contactErr(e2)); } finally { setBusy(false); }
  };
  return (
    <main className="min-h-screen argus-root argus-bg text-[#f0fdf4] flex flex-col" data-testid="argus-contact-page">
      <header className="border-b border-white/10 px-5 py-3 flex items-center gap-2">
        <Link to="/argus" className="flex items-center gap-2"><Eye className="w-5 h-5 text-[#10b981]" /><span className="argus-display text-xl font-bold">Argus</span></Link>
      </header>
      <section className="max-w-2xl w-full mx-auto px-5 py-12 flex-1">
        <Label>Contact us</Label>
        <h1 className="argus-display text-4xl sm:text-5xl font-bold mt-2">Get in touch.</h1>
        <p className="text-white/60 mt-3 text-sm">Questions about plans, WHIP, directory listings, billing or privacy. We reply to the email you give, usually within one business day. Never send whistleblower evidence here; use a tip line instead.</p>
        {sent ? (
          <div className="mt-8 p-6 rounded-lg argus-glass" data-testid="argus-contact-sent"><CheckCircle2 className="w-6 h-6 text-[#34d399]" /><div className="font-semibold mt-2">Message sent. Thank you!</div><p className="text-sm text-white/60 mt-1">We'll reply to {f.email}.</p></div>
        ) : (
          <form onSubmit={submit} className="mt-8 p-6 rounded-lg argus-glass space-y-3" data-testid="argus-contact-form">
            <div className="grid sm:grid-cols-2 gap-3">
              <input required className={inputCls} value={f.name} onChange={set("name")} placeholder="Your name" data-testid="argus-contact-name" />
              <input required type="email" className={inputCls} value={f.email} onChange={set("email")} placeholder="Your email" data-testid="argus-contact-email" />
            </div>
            <select className={inputCls} value={f.topic} onChange={set("topic")} data-testid="argus-contact-topic">{TOPICS.map(t => <option key={t}>{t}</option>)}</select>
            <textarea required minLength={5} rows={6} className={inputCls} value={f.message} onChange={set("message")} placeholder="How can we help?" data-testid="argus-contact-message" />
            <input type="text" tabIndex={-1} autoComplete="off" className="hidden" value={f.website} onChange={set("website")} aria-hidden="true" />
            {err && <div className="text-red-300 text-sm" data-testid="argus-contact-error">{err}</div>}
            <Btn type="submit" busy={busy} data-testid="argus-contact-submit"><Send className="w-3.5 h-3.5" /> Send message</Btn>
          </form>
        )}
      </section>
      <ArgusLegalFooter />
    </main>
  );
}
